var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('postulant-details-component',{attrs:{"ui":'admin',"routeToList":'admin-postulants-list'}})}
var staticRenderFns = []

export { render, staticRenderFns }